import { render, staticRenderFns } from "./KemaskiniMaklPemohon.vue?vue&type=template&id=7b96336c&scoped=true&"
import script from "./KemaskiniMaklPemohon.vue?vue&type=script&lang=js&"
export * from "./KemaskiniMaklPemohon.vue?vue&type=script&lang=js&"
import style0 from "./KemaskiniMaklPemohon.vue?vue&type=style&index=0&id=7b96336c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b96336c",
  null
  
)

export default component.exports